import { render } from "./Jumbotron.vue?vue&type=template&id=24898627"
import script from "./Jumbotron.vue?vue&type=script&lang=js"
export * from "./Jumbotron.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/Jumbotron.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24898627"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24898627', __exports__)) {
    api.reload('24898627', __exports__)
  }
  
  module.hot.accept("./Jumbotron.vue?vue&type=template&id=24898627", () => {
    api.rerender('24898627', render)
  })

}


export default __exports__